module.exports = __webpack_public_path__ + "25c52bb1e8c017f30686f5405005ef54.png";